import React from "react";

export const IconSignout = () => (
  <svg id="Flat" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <path d="M224.51465,136.48535l-42,42a12.0001,12.0001,0,1,1-16.9707-16.9707L187.05859,140H104a12,12,0,0,1,0-24h83.05859L165.544,94.48535a12.0001,12.0001,0,1,1,16.9707-16.9707l42,42A11.99975,11.99975,0,0,1,224.51465,136.48535ZM120,204H52V52h68a12,12,0,0,0,0-24H48A20.02229,20.02229,0,0,0,28,48V208a20.02229,20.02229,0,0,0,20,20h72a12,12,0,0,0,0-24Z" />
  </svg>
);
